import { useToast } from "hooks/useToasts";
import { useEffect } from "react";

import type { LPQuoteInput } from "../../types/Rater.types";
import { removeFormsWithToast } from "../utils/removeFormsWithToast";
import { BusinessRulesArgs } from "./useBusinessRules";

const LIABILITY_FORMS = ["FL46A"];

export function isLiabilityRuleForm(formName: string) {
  return LIABILITY_FORMS.includes(formName);
}

function isLiabilityFormEligible({
  formName,
  formsData,
  rateOptions,
  tabItem,
}: Pick<BusinessRulesArgs, "formsData" | "tabItem"> & {
  formName: string;
  rateOptions: LPQuoteInput;
}) {
  return formsData[formName]?.addable?.(rateOptions, tabItem) ?? false;
}

export function useLiabilityRules({
  getValues,
  tabItem,
  forms,
  formsData,
  enabled,
  removeForm,
  liabilityForm,
  liability,
}: BusinessRulesArgs) {
  const { addToast } = useToast();

  // {START: Remove liability forms when the quote is no longer eligible}
  useEffect(() => {
    if (!enabled) return;

    const rateOptions = getValues();
    const formsToRemove = forms.map((form, index) => ({ form, index })).filter(({ form }) => {
      return (
        isLiabilityRuleForm(form.name) &&
        !isLiabilityFormEligible({
          formName: form.name,
          formsData,
          rateOptions,
          tabItem,
        })
      );
    });

    removeFormsWithToast({ addToast, removeForm, formsData, formsToRemove, reason: "due to a change in liability" });
  }, [liability, liabilityForm, forms, removeForm, formsData, enabled, addToast, getValues, tabItem]);
  // {END: Remove liability forms when the quote is no longer eligible}
}
